<template>
  <div class="dash-pager" v-if="meta">
    <b-pagination
      class="dash-pager-pages"
      @change="onChangePage"
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      :limit="limit"
      hide-ellipsis
      first-number
      last-number
    ></b-pagination>
    <span class="dash-pager-total">تعداد کل {{ formatNumber(totalRows) }}</span>
  </div>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "Pagination",
  methods: {formatNumber},
  props: ['meta', 'onChangePage'],
  data() {
    return {
      currentPage: 1,
    }
  },
  computed: {
    totalRows() {
      return (this.meta && this.meta.total) || 0;
    },
    perPage() {
      return (this.meta && this.meta.per_page) || 10;
    },
    limit() {
      return 5;
    }
  },
  watch: {
    meta: {
      immediate: true,
      handler(value) {
        if (value && value.current_page) {
          this.currentPage = Number(value.current_page)
        }
      }
    }
  }
}
</script>

<style scoped>
.dash-pager {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px 16px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.dash-pager-pages {
  margin: 0 !important;
  flex: 1 1 auto;
  max-width: 100%;
}

.dash-pager >>> .pagination {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin: 0;
  max-width: 100%;
}

.dash-pager >>> .page-item {
  margin: 0;
}

.dash-pager >>> .page-item .page-link {
  min-width: 36px;
  height: 36px;
  border: none !important;
  border-radius: 12px !important;
  background: #1e1e1e !important;
  color: #fff !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  font-weight: 700;
  line-height: 1;
  box-shadow: none !important;
}

.dash-pager >>> .page-item .page-link span,
.dash-pager >>> .page-item .page-link svg {
  color: #fff !important;
  fill: #fff !important;
}

.dash-pager >>> .page-item.disabled .page-link {
  background: #f0f0f0 !important;
  color: #9ca3af !important;
}

.dash-pager >>> .page-item.disabled .page-link span,
.dash-pager >>> .page-item.disabled .page-link svg {
  color: #9ca3af !important;
  fill: #9ca3af !important;
}

.dash-pager >>> .page-item.active .page-link,
.dash-pager >>> .page-item .page-link:hover,
.dash-pager >>> .page-item .page-link:focus {
  background: #eb3d60 !important;
  color: #fff !important;
}

.dash-pager >>> .page-item.active .page-link span,
.dash-pager >>> .page-item.active .page-link svg,
.dash-pager >>> .page-item .page-link:hover span,
.dash-pager >>> .page-item .page-link:hover svg {
  color: #fff !important;
  fill: #fff !important;
}

.dash-pager-total {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  color: #6b7280;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 999px;
  padding: 8px 14px;
  white-space: nowrap;
}

@media (max-width: 767px) {
  .dash-pager {
    justify-content: center;
  }

  .dash-pager-total {
    width: 100%;
    text-align: center;
  }
}
</style>
